import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { loginStoreActions, RootStoreState } from '@app/root-store';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { Dimensions, ImageCroppedEvent, ImageTransform } from '@app/shared/packages/image-cropper/interfaces';
import { FileUploadService } from '@app/shared/services/file-upload/file-upload.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'bs-file-upload-new',
  templateUrl: './bs-file-upload-new.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BsFileUploadNewComponent implements OnInit, OnDestroy {
  imageChangedEvent: any = '';
  croppedImage: any;
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  showCropper = false;
  format = null;
  showdiv = false;
  containWithinAspectRatio = false;
  videoMimeType: any;
  resizeToWidth = 465;
  cropperMinWidth = 250;
  transform: ImageTransform = {};
  @ViewChild('videoPlayer') videoplayer: ElementRef;
  loginStateObject;
  imageUploadedSuccess = false;
  showLoader = false;
  subscription = new Subscription();
  isSquareImage: boolean = false;
  screenWidth: number;

  constructor(
    private fileUploadService: FileUploadService,
    public activeModal: NgbActiveModal,
    private cd: ChangeDetectorRef,
    private loginService: LoginStoreEffects,
    private store$: Store<RootStoreState.State>,
    private dialogRef: MatDialogRef<BsFileUploadNewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.loginStateObject = state.data;
      })
    );

    if (this.loginStateObject.profile_image_url) {
      this.imageUploadedSuccess = true;
    }
  }

  closeDialog() {
    this.dialogRef.close();
    this.toastr.error(`No image added`);
  }

  ngOnInit() {
    if (this.data.format.indexOf('image') > -1) {
      this.format = 'image';
      this.showdiv = true;
      this.imageChangedEvent = this.data.imageChangedEvent;
      this.cd.markForCheck();
    }
    if (this.data.format.indexOf('video') > -1) {
      this.format = 'video';
      this.videoMimeType = this.data.videoMimeType;
      var reader = new FileReader();
      reader.readAsDataURL(this.data.imageChangedEvent.target.files[0]);
      reader.onload = (file) => {
        this.croppedImage = reader.result;
        this.cd.markForCheck();
      };
    }
    if (this.data.type == '') {
      this.resizeToWidth = 150;
      this.cropperMinWidth = 250;
    }

    if (this.loginStateObject.profile_image_url) {
      this.imageUploadedSuccess = true;
    }

    if (this.data.isSquareImage) {
      this.isSquareImage = this.data.isSquareImage;
      this.cd.detectChanges();
    }
    this.screenWidth = window.innerWidth;
  }
  fileChangeEvent(event: any): void {
    const file = event.target.files && event.target.files[0];
    if (file) {
      if (file.type.indexOf('image') > -1) {
        this.format = 'image';
        this.showdiv = true;
        this.imageChangedEvent = event;
        this.cd.markForCheck();
      } else if (file.type.indexOf('video') > -1) {
        this.format = 'video';
        this.videoMimeType = file.type;
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (file) => {
          this.croppedImage = reader.result;
          this.cd.markForCheck();
        };
      }
    }
  }
  toggleVideo(event: any) {
    this.videoplayer.nativeElement.play();
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    this.showCropper = true;
  }

  cropperReady(sourceImageDimensions: Dimensions) {}

  loadImageFailed() {}

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {};
  }

  zoomOut() {
    this.scale -= 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  zoomIn() {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  toggleContainWithinAspectRatio() {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  updateRotation() {
    this.transform = {
      ...this.transform,
      rotate: this.rotation,
    };
  }
  uploadFile(file) {
    let fd;
    if (this.data.type == 'guardian') {
      fd = {
        file: this.croppedImage,
        type: this.format,
        user_id: this.data?.guardianId,
        img_type: this.data?.extension,
      };
    } else if (this.data.type == 'vault-form') {
      fd = {
        file: this.croppedImage,
        vaultId: this.data.vaultId,
        fileName: this.data.fileName,
        type: this.data.format,
      };
    } else {
      fd = {
        file: this.croppedImage,
        type: this.format,
      };
    }

    switch (this.data.type) {
      case 'profile':
        if (Buffer.byteLength(this.croppedImage, 'utf8') > 10242 * 10242 * 15) {
          this.toastr.error('Image exceeds max size, please try again.');
          this.showLoader = false;
          return;
        }
        this.profilepic(fd);
        break;
      case 'post-upload':
        this.postpic(fd);
        this.dialogRef.close({
          confirmation: true,
        });
        break;
      case 'message-upload':
        this.messagepic(fd);
        this.dialogRef.close({
          confirmation: true,
        });
        break;
      case 'org':
        if (Buffer.byteLength(this.croppedImage, 'utf8') > 10242 * 10242 * 15) {
          this.toastr.error('Image exceeds max size, please try again.');
          this.showLoader = false;
          return;
        }
        this.orgpic(fd);
        break;
      case 'guardian':
        this.guardianPic(fd);

        break;
      case 'vault-form':
        this.vaultFormPic(fd);

        break;
      case 'map-avatar':
        if (Buffer.byteLength(this.croppedImage, 'utf8') > 10242 * 10242 * 15) {
          this.toastr.error('Image exceeds max size, please try again.');
          this.showLoader = false;
          return;
        }
        fd['node'] = this.data.node;
        this.assetMapPic(fd);
        break;
      default:
        this.dialogRef.close({
          confirmation: true,
          fd,
        });
        break;
    }
  }

  messagepic(input) {
    this.subscription.add(
      this.fileUploadService.messagePic(input).subscribe(
        (data: any) => {
          this.store$.dispatch(new loginStoreActions.LoginRequestAction());
          this.activeModal.close(data);
        },
        (error: any) => {
          this.activeModal.close(error);
        }
      )
    );
  }
  postpic(input) {
    this.subscription.add(
      this.fileUploadService.postPic(input).subscribe(
        (data: any) => {
          this.activeModal.close(data);
        },
        (error: any) => {
          this.activeModal.close(error);
        }
      )
    );
  }
  orgpic(input) {
    this.subscription.add(
      this.fileUploadService.infoPic(input, 'org').subscribe(
        (upload_promise: any) => {
          this.showLoader = false;
          this.dialogRef.close(upload_promise);
        },
        (error: any) => {
          this.activeModal.close(error);
        }
      )
    );
  }
  profilepic(input) {
    this.subscription.add(
      this.fileUploadService.profilePic(input).subscribe(
        (upload_promise: any) => {
          this.showLoader = false;
          this.dialogRef.close(upload_promise);
        },
        (error: any) => {
          this.activeModal.close(error);
        }
      )
    );
  }
  assetMapPic(input) {
    this.subscription.add(
      this.fileUploadService.assetMapPic(input).subscribe(
        (upload_promise: any) => {
          this.showLoader = false;
          this.dialogRef.close({
            confirm: true,
            input,
            upload_promise,
          });
        },
        (error: any) => {
          this.activeModal.close(error);
        }
      )
    );
  }
  DataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',');
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
    return new Blob([ia], { type: mimeString });
  }

  uploadFiles() {
    this.showLoader = true;
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.value = '';
    //this.files.forEach(file => {
    this.uploadFile(fileUpload);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  async guardianPic(input) {
    if (input?.user_id == 'noId') {
      localStorage.setItem('guardianImageToBeUploaded', JSON.stringify(input));
      this.subscription.add(this.dialogRef.close('noId'));
    } else {
      this.subscription.add(
        this.fileUploadService.guardianImage(input).subscribe(
          (upload_promise: any) => {
            this.showLoader = false;
            this.dialogRef.close(upload_promise);
          },
          (error: any) => {
            this.activeModal.close(error);
          }
        )
      );
    }
  }
  vaultFormPic(input) {
    this.subscription.add(
      this.fileUploadService.vaultFOrmImage(input).subscribe(
        (upload_promise: any) => {
          this.showLoader = false;
          this.dialogRef.close(upload_promise);
        },
        (error: any) => {
          this.activeModal.close(error);
        }
      )
    );
  }
}
